module.exports = __webpack_public_path__ + "assets/media/arrow-bottom-prize.e9414164.svg";